import {Component, Inject, Input, OnDestroy, OnInit} from "@angular/core";
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {first} from "rxjs/operators";
import {BehaviorSubject, of, Subscription} from "rxjs";
import {LIST_TYPE_INPUT} from "./model-crud/crud.model";
import {DatePipe} from '@angular/common';
import {SweetAlertService} from "../shared/services/common/sweet-alert.service";

@Component({
  selector: 'app-base-bpmn-edit-pages',
  templateUrl: './edit-crud/edit-bpmn-modal.component.html',
  styleUrls: ['./edit-crud/edit-crud-modal.component.scss'],
})

export class BaseBpmnEditPagesComponent implements OnInit, OnDestroy {
  @Input() id: number;
  @Input() type: string;
  @Input() show: boolean;
  @Input() title: string;
  @Input() typeDecision: string;
  @Input() arrform: string;
  @Input() arrvar: string;
  @Input() arrDecision: any[];
  @Input() arrParamsGroup: {
    title: string,
    form: string,
    type?: string,
    url?: string,
    metaData?: any,
    placeHolder?: string,
    name?: string,
    readonly?: boolean,
    mandatory?: boolean
  }[];
  @Input() arrFormGroup: {
    title: string,
    form: string,
    type?: string,
    url?: string,
    metaData?: any,
    placeHolder?: string,
    name?: string,
    readonly?: boolean,
    mandatory?: boolean
  }[];
  @Input() formCustom: any;

  //for form
  isLoading$;
  formObj: any;
  formGroup: FormGroup;
  subscriptions: Subscription[] = [];
  htmlInputType = LIST_TYPE_INPUT;
  EMPTY_OBJ: {} = {};
  listInput = [
    'text',
    'number',
    'email',
    'list'
  ];

  //diagram
  diagramUrl = ``;
  diagramUrlDetail = '';
  isCollapsed = false;
  importError?: Error;

  //handle form variable and dto
  arrNameOfForm: any[] = [];
  arrNameOfVar: any[] = [];

  // hide logs when create new bpmn
  applyHide = false;

  syncFoo = "foo";
  testEmitter$ = new BehaviorSubject<any>(this.syncFoo);

  arrCheckboxList = [];

  //handle form with type date
  arrTempDate = [];
  datePipe = new DatePipe('en-US');

  constructor(
    @Inject('') protected service: any,
    protected fb: FormBuilder,
    public modal: NgbActiveModal
  ) {
  }

  ngOnInit(): void {
    this.isLoading$ = this.service.isLoading$;
    this.loadFormData();
  }

  loadFormData() {
    if (!this.id) {
      this.formObj = this.EMPTY_OBJ;
      this.loadForm();
    } else {
      const sb = this.service.getItemBpmnById(this.id).pipe(
        first()
      ).subscribe((res: any) => {
        // SweetAlertService.swalSuccess(res);
        const logs = res.data.logs;
        let model = res.data.object;
        let typeTask = '';
        let nameTask = '';
        for (var key in model.tasks) {
          if (model.tasks.hasOwnProperty(key)) {
            typeTask = key
            nameTask = model.tasks[key]
          }
        }
        model = {
          ...model,
          typeTask,
          nameTask
        }
        //init form object
        this.formObj = {
          logs,
          model
        }
        this.loadForm();
      }, (error) => {
        SweetAlertService.swalError(error)
        this.modal.dismiss('error');
      });
      this.subscriptions.push(sb);
    }
  }

  // OVERRIDE THIS (ADD CUSTOM FORMCONTROLL AND VALIDATION)
  loadForm() {
    if (this.id) {
      this.diagramUrl = `${this.diagramUrlDetail}/${this.id}/xml`;
    } else {
      this.applyHide = true;
    }
    this.initArrVarDto();
    this.initFormGroup();
  }

  initArrVarDto() {
    this.arrNameOfForm = this.arrFormGroup.map((el) => {
      if (el.type == 'checkbox') {
        this.arrCheckboxList.push(el.form)
      }
      if (el.type == 'date') {
        this.arrTempDate.push(el.form)
      }
      return el.form;
    });
    this.arrNameOfVar = this.arrParamsGroup.map((el) => {
      return el.form;
    });
    for (const key of this.arrNameOfForm) {
      this.EMPTY_OBJ[key] = key;
    }
    for (const key of this.arrNameOfVar) {
      this.EMPTY_OBJ[key] = key;
    }
  }

  initFormGroup() {
    const objFormGroup = new Object();
    // generate obj FORM database
    this.arrNameOfForm.forEach((el) => {
      //check validate
      const findItem = this.arrFormGroup.find((item, index) => {
        if (item.form === el) {
          return true;
        } else {
          return false;
        }
      });
      let validate = [];
      if (findItem) {
        if (findItem.mandatory) {
          validate.push(Validators.required);
        }
      }
      if (this.arrCheckboxList.includes(el)) {
      } else {
        objFormGroup[el] = [this.id ? this.formObj.model[el] : '', Validators.compose(validate)];
      }
    });
    // generate obj Variables Camunda
    this.arrNameOfVar.forEach((el) => {
      //check validate
      const findItem = this.arrParamsGroup.find((item, index) => {
        if (item.form === el) {
          return true;
        } else {
          return false;
        }
      });
      let validate = [];
      if (findItem) {
        if (findItem.mandatory) {
          validate.push(Validators.required);
        }
      }
      objFormGroup[el] = ['', Validators.compose(validate)];
    });
    // generate decision Camunda
    if (this.arrDecision.length) {
      objFormGroup['decision'] = ['', Validators.compose([Validators.required])];
    }

    // angular formGroup
    this.formGroup = this.fb.group(objFormGroup);

    //for checkbox
    this.arrNameOfForm.forEach((el) => {
      if (this.arrCheckboxList.includes(el)) {
        this.formGroup.addControl(el, this.fb.array([]));
      }
    })
  }

  save() {
    this.prepareFormData();
    if (this.formObj.model.id) {
      this.edit();
    } else {
      this.create();
    }
  }

  edit() {
    const sbUpdate = this.service
      .updateBpmn(this.formObj.model.id, this.prepareFormEdit(), this.type, this.prepareParamsEdit())
      .pipe()
      .subscribe((res: any) => {
        SweetAlertService.swalSuccess(res);
        this.modal.dismiss('success');
        return true
      }, (error) => {
        SweetAlertService.swalError(error);
        this.modal.dismiss('error');
      });
    this.subscriptions.push(sbUpdate);
  }

  create() {
    const sbCreate = this.service.apply(this.prepareFormData(), this.prepareParamsData())
      .pipe()
      .subscribe((res: any) => {
        SweetAlertService.swalSuccess(res);
        this.modal.dismiss('success');
        return true
      }, (error) => {
        SweetAlertService.swalError(error);
        this.modal.dismiss('error');
      });
    this.subscriptions.push(sbCreate);
  }

  editCustom() {
    // Use this if wanna add something after post
    const sbUpdate = this.service.updateBpmn(this.formObj.model.id, this.prepareFormEdit(), this.type, this.prepareParamsEdit())
      .pipe()
      .subscribe((res: any) => {
        this.custom(res);
      }, (error) => {
        SweetAlertService.swalError(error);
        this.modal.dismiss('error');
      });
    this.subscriptions.push(sbUpdate);
  }

  createCustom(obj, arr, customUrl = null) {
    // Use this if wanna add something after post
    const sbCreate = this.service.apply(obj, arr, customUrl)
      .pipe()
      .subscribe((res: any) => {
        this.custom(res);
      }, (error) => {
        SweetAlertService.swalError(error);
        this.modal.dismiss('error');
      });
    this.subscriptions.push(sbCreate);
  }

  custom(res) {
  //  override this
  }

  prepareFormData() {
    //    OVERRIDE THIS
    const formData = this.formGroup.value;
    let obj = new Object();
    this.arrNameOfForm.forEach((el) => {
      if (formData[el]) {
        if (this.arrTempDate.includes(el)) {
          obj[el] = this.datePipe.transform(formData[el], 'yyyy-MM-dd')
        } else {
          obj[el] = formData[el];
        }
      }
    });
    return obj;
  }

  prepareFormEdit() {
    //    OVERRIDE THIS
    this.prepareFormData();
  }

  prepareParamsData() {
    //    OVERRIDE THIS
    const formParams = this.formGroup.value;
    const arrTemp = [];
    this.arrNameOfVar.forEach((el) => {
      if (formParams[el]) {
        arrTemp.push({
          name: el,
          value: formParams[el]
        });
      }
    });
    // //decision hard code dlu
    if (this.arrDecision.length) {
      arrTemp.push({
        name: 'decision',
        value: formParams['decision']
      });
    } else {
      if (this.typeDecision == 'radio') {
        arrTemp.push({
          name: 'decision',
          value: 'ok'
        });
      }
    }
    //if have arrNameOfVar
    if (this.arrNameOfForm.length) {
      arrTemp.push({
        name: 'withVariable',
        value: '1'
      });
    }
    return arrTemp;
  }

  prepareParamsEdit() {
    //    OVERRIDE THIS
    this.prepareParamsData();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }

  onCheckChange(event, name) {
    const formArray: FormArray = this.formGroup.get(name) as FormArray;
    if (event.target.checked) {
      formArray.push(new FormControl(event.target.value));
    } else {
      let i: number = 0;
      formArray.controls.forEach((ctrl: FormControl) => {
        if (ctrl.value == event.target.value) {
          formArray.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

  // For Bpmn Viewer Handler
  handleImported(event) {
    const {
      type,
      error,
      warnings
    } = event;

    if (type === 'success') {
      console.log(`Rendered diagram (%s warnings)`, warnings.length);
    }

    if (type === 'error') {
      console.error('Failed to render diagram', error);
    }
    this.importError = error;
  }

  // get validator
  getValidatorVal() {
    // OVERRIDE THIS IF WANT TO CUSTOM
    //check form
    let bol = false;
    this.arrFormGroup.forEach((el) => {
      if (el.mandatory) {
        if (!this.formGroup.controls[el.form].value) {
          bol = true;
        }
      }
    })
    this.arrParamsGroup.forEach((el) => {
      if (el.mandatory) {
        if (!this.formGroup.controls[el.form].value) {
          bol = true;
        }
      }
    })
    if (this.arrDecision.length) {
      if (!this.formGroup.controls['decision'].value) {
        bol = true;
      }
    }
    return bol
  }

  // helpers for View
  isControlValid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.valid && (control.dirty || control.touched);
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.formGroup.controls[controlName];
    return control.invalid && (control.dirty || control.touched);
  }

  controlHasError(validation, controlName): boolean {
    const control = this.formGroup.controls[controlName];
    return control.hasError(validation) && (control.dirty || control.touched);
  }

  isControlTouched(controlName): boolean {
    const control = this.formGroup.controls[controlName];
    return control.dirty || control.touched;
  }
}
